import "./deep-dive.scss";
import Handles from "components/app/project/deep-dive-breakdown/handles/index";
import DeepDivePie from "components/app/project/deep-dive-pie/index";
import { useEffect, useState, useCallback, useRef } from "react";
import { useParams } from "react-router";
import Heatmap from "components/app/project/heatmap";
import moment from "moment";
import FiltersMenu from "components/app/project/filters-menu";
import { RootState } from "types";
import { useSelector } from "react-redux";
import WorldMap from "components/app/project/world-map";
import WordCloudComponent from "components/app/project/word-cloud/word-cloud";
import api from "api";
import { DeepDiveType } from "types";
import ClipTray from "components/app/clip-tray/clip-tray";

function DeepDive() {
    const params: any = useParams();
    const [rail, setRail] = useState("Hashtag");
    const [breakDownPeriod, setBreakDownPeriod] = useState<string>("Weekly");

    const buttonRef = useRef<any>();
    const [hashIsActive, setHashIsActive] = useState(true);
    const [urlIsActive, setUrlIsActive] = useState(false);
    const [handlesIsActive, setHandlesIsActive] = useState(false);
    const [entitiesIsActive, setEntitiesIsActive] = useState(false);
    const [periodDisplay, setPeriodDisplay] = useState("ama-dropdown");
    const [dateFrom, setDateFrom] = useState(moment().subtract(1, "d").set("h", 0).set("m", 0).set("s", 0));
    const [dateTo, setDateTo] = useState(moment());
    const selectedDate = useRef<Date>(dateTo.toDate());
    const [streamIds, setStreamIds] = useState<number[]>([7, 8, 9]);
    const [filtersOpen, setFiltersOpen] = useState(false);
    const state = useSelector((state: RootState) => state);
    const [project, setProject] = useState<any>();
    const [diveData, setDiveData] = useState<DeepDiveType[]>([]);
    const [prefix, setPrefix] = useState<string>("#");
    const [valuesDisplay, setValuesDisplay] = useState<any[]>([]);
    const values = useRef<any[]>([]);
    const [initialVals, setInitialVals] = useState<any[]>(["mediaupdate", "Mediaupdate"]);
    const [vals, setVals] = useState<any[]>([initialVals]);

    const GetDiveData = useCallback(async () => {
        const data = await api.deepDiveBreakdown.getOwned(params.projectId, dateFrom, dateTo, rail, streamIds);
        if (data.status !== 204) {
            setDiveData(data);
        }
        values.current = [];
    }, [params.projectId, dateFrom, dateTo, rail, streamIds]);

    useEffect(() => {
        GetDiveData();
    }, [GetDiveData]);

    useEffect(() => {
        setValuesDisplay([]);
    }, [diveData, rail]);

    useEffect(() => {
        setVals(["mediaupdate", "Mediaupdate"]);
    }, [rail]);

    useEffect(() => {
        if (state.project) {
            setProject(state.project);
            setStreamIds([7, 8, 9]);
            if (state.project.ProjectTypeId === 5) {
                setStreamIds([7, 8, 9]);
            } else {
                if (state.project.ProjectSubTypeId === 7) {
                    setStreamIds([7]);
                } else if (state.project.ProjectSubTypeId === 8) {
                    setStreamIds([8]);
                } else if (state.project.ProjectSubTypeId === 9) {
                    setStreamIds([10]);
                } else if (state.project.ProjectSubTypeId === 10) {
                    setStreamIds([9]);
                } else if (state.project.ProjectSubTypeId === 11) {
                    setStreamIds([11]);
                }
            }
        }
    }, [state.project]);

    function ShowPeriodSelection() {
        if (periodDisplay === "ama-dropdown") {
            setPeriodDisplay("ama-dropdown open");
        } else if (periodDisplay === "ama-dropdown open") {
            setPeriodDisplay("ama-dropdown");
        }
    }

    function ToggleRailComparison() {
        setInitialVals([]);
        console.log("Initial Vals on CLick", initialVals);
        diveData.forEach((x: DeepDiveType) => {
            if (!values.current.includes(x.Value)) {
                values.current.push(x.Value);
            }
        });
        setValuesDisplay(values.current);
        if (document.getElementById("rail-select-modal")!.style.display === "block") {
            document.getElementById("rail-select-modal")!.style.display = "none";
        } else if ((document.getElementById("rail-select-modal")!.style.display = "none")) {
            document.getElementById("rail-select-modal")!.style.display = "block";
        } else {
            document.getElementById("rail-select-modal")!.style.display = "none";
        }
    }

    function PushCheckBox(val: any) {
        if (initialVals.includes(val)) {
            setInitialVals(initialVals.filter((x) => x !== val));
        } else {
            setInitialVals([...initialVals, val]);
        }
        console.log("After Checkbox", initialVals);
    }

    function ChangeVals() {
        if (initialVals.length === 0) {
            alert("Choose at least 1 item to compare");
        } else {
            setVals([]);
            setVals(initialVals);
            console.log("Updated Vals", vals);
        }
    }

    function SelectedRail(x: string) {
        if (x === "urls") {
            setRail("Url");
            setPrefix("");
            setHashIsActive(false);
            setUrlIsActive(true);
            setEntitiesIsActive(false);
            setHandlesIsActive(false);
        } else if (x === "hashtags") {
            setRail("Hashtag");
            setPrefix("#");
            setHashIsActive(true);
            setUrlIsActive(false);
            setEntitiesIsActive(false);
            setHandlesIsActive(false);
        } else if (x === "handles") {
            setRail("Handle");
            setPrefix("@");
            setHashIsActive(false);
            setUrlIsActive(false);
            setEntitiesIsActive(false);
            setHandlesIsActive(true);
        } else if (x === "entities") {
            setRail("Entities");
            setPrefix("");
            setHashIsActive(false);
            setUrlIsActive(false);
            setEntitiesIsActive(true);
            setHandlesIsActive(false);
        }
    }

    function OnCheckboxChange(e: React.ChangeEvent<HTMLInputElement>) {
        var value = e.currentTarget.value;
        PushCheckBox(value);
    }

    return (
        <>
            <div id="Deep-Dive">
                <div id="_DeepDiveSelection">
                    <div className="deep-dive-selection">
                        <p className={hashIsActive ? "selected" : ""} id="hashtags" onClick={() => SelectedRail("hashtags")}>
                            <i className="fal fa-hashtag"></i> hashtags
                        </p>
                        <p className={urlIsActive ? "selected" : ""} id="urls" onClick={() => SelectedRail("urls")}>
                            <i className="fal fa-globe"></i> urls
                        </p>
                        <p className={handlesIsActive ? "selected" : ""} id="3" onClick={() => SelectedRail("handles")}>
                            <i className="fal fa-at"></i> handles
                        </p>
                        <p className={entitiesIsActive ? "selected" : ""} id="4" onClick={() => SelectedRail("entities")}>
                            <i className="fal fa-users-class"></i> named entities
                        </p>
                    </div>
                    <div id="deep-dive-container" className="deep-dive-container"></div>
                </div>

                <Handles rail={rail} breakDownPeriod={breakDownPeriod} selectedDate={selectedDate.current} clientId={params.clientId} projectId={params.projectId} streamIds={streamIds} dateTo={dateTo} dateFrom={dateFrom} vals={vals} />

                <DeepDivePie rail={rail} breakDownPeriod={breakDownPeriod} dateTo={dateTo} vals={vals} diveData={diveData} />

                <div className="top-buttons">
                    <span id="filter" ref={buttonRef} onClick={() => setFiltersOpen(true)}>
                        Filter
                        <i className={`fal ${filtersOpen ? "fa-times" : "fa-sliders-h"}`}></i>
                    </span>
                    <FiltersMenu
                        open={filtersOpen}
                        setOpen={setFiltersOpen}
                        dateFrom={dateFrom}
                        setDateFrom={setDateFrom}
                        dateTo={dateTo}
                        setDateTo={setDateTo}
                        streamIds={streamIds}
                        setStreamIds={setStreamIds}
                        projectTypeId={project?.ProjectTypeId}
                        showDatePicker={true}
                        buttonRef={buttonRef}
                    />
                    <div className="rail-comparison-button">
                        <a id="open-rail-comparison" onClick={ToggleRailComparison}>
                            {" "}
                            Compare{" "}
                        </a>
                    </div>

                    <div className={periodDisplay} onClick={() => ShowPeriodSelection()}>
                        <span>{breakDownPeriod}</span>
                        <ul id="date-frequencies" className={periodDisplay}>
                            <li onClick={() => setBreakDownPeriod("Hourly")}>Hourly</li>
                            <li onClick={() => setBreakDownPeriod("Daily")} className="selected">
                                Daily
                            </li>
                            <li onClick={() => setBreakDownPeriod("Weekly")}>Weekly</li>
                        </ul>
                    </div>
                </div>
                <div id="rail-select-modal" className="rail-select-modal">
                    <p className="modal-heading">Select items to compare - Up to 5</p>
                    <span className="close" onClick={ToggleRailComparison}>
                        &times;
                    </span>
                    <div id="rail-items-list" className="rail-items">
                        {valuesDisplay.map((x) => (
                            <div className="rail-item">
                                <input type="checkbox" className="rail-item-input" value={x} onChange={(e) => OnCheckboxChange(e)}></input>
                                <label className="rail-item-form-label" htmlFor="check-rail-item">
                                    {prefix} {x}
                                </label>
                            </div>
                        ))}
                    </div>
                    <button className="update-rail-items" onClick={ChangeVals}>
                        <i className="far fa-check text-white"></i>
                    </button>
                </div>
                <div className="modal-body-container"></div>
                <ClipTray />
                <Heatmap projectId={params.projectId} dateFrom={dateFrom} dateTo={dateTo} streamIds={streamIds} />
                <WordCloudComponent projectId={params.projectId} dateFrom={dateFrom} dateTo={dateTo} streamIds={streamIds} />
                {/* <WorldMap projectId={params.projectId} dateFrom={dateFrom} dateTo={dateTo} streamIds={streamIds} /> */}
            </div>
        </>
    );
}

export default DeepDive;
